var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.003 33.5247H190.833C189.321 33.5247 188.587 32.8071 188.587 31.3305C188.587 29.8538 189.301 29.1362 190.833 29.1362H219.938V17.9751H190.833C182.499 17.9751 177.115 22.8885 177.115 30.4913C177.115 38.0941 182.585 42.9571 190.726 42.9571H208.003C211.142 42.9571 211.142 44.8874 211.142 45.519C211.142 47.5502 209.435 47.9772 208.003 47.9772H177.693L177.707 59.1383H208.003C216.53 59.1383 221.825 54.1804 221.825 46.201C221.825 40.4189 219.428 33.5277 208.003 33.5277V33.5247Z",
    fill: "url(#paint0_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.009 20.7921C151.679 18.5711 149.924 17.4444 147.8 17.4444C145.675 17.4444 143.923 18.5711 142.59 20.7891L119.551 59.1323H132.312L147.485 33.3943L151.863 40.7717H145.005L139.537 50.0944H157.401L162.756 59.1323H176.074C176.009 59.0493 175.965 58.9959 175.897 58.8951L153.003 20.7891L153.009 20.7921Z",
    fill: "url(#paint1_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.772 34.0496H104.375V43.9504H125.772V34.0496Z",
    fill: "url(#paint2_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.348 17.9722H91.457V59.1353H102.561V29.1332H127.348V17.9722Z",
    fill: "url(#paint3_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.804 17.9722V29.1332H235.825V59.1353H246.98V29.1332H261V17.9722H221.804Z",
    fill: "url(#paint4_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.939 57.6527V19.4548H125.864V27.6506H101.077V57.6527H92.936H92.939ZM105.857 42.4678V35.5322H124.29V42.4678H105.857Z",
    fill: "url(#paint5_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.171 57.6527V49.4568H208C210.94 49.4568 212.621 47.9327 212.621 45.5161C212.621 42.9423 210.94 41.4715 208 41.4715H190.723C183.214 41.4715 178.594 36.9525 178.594 30.4883C178.594 24.0242 182.899 19.4548 190.83 19.4548H218.453V27.6506H190.83C188.518 27.6506 187.102 28.9642 187.102 31.3275C187.102 33.6908 188.572 35.0044 190.83 35.0044H208C216.035 35.0044 220.341 38.5775 220.341 46.1951C220.341 52.7631 216.298 57.6497 208 57.6497H179.171V57.6527Z",
    fill: "url(#paint6_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.307 57.6527V27.6506H223.286V19.4548H259.521V27.6506H245.501V57.6527H237.31H237.307Z",
    fill: "url(#paint7_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5578 70.8271V69.4216H96.5009C97.0047 69.4216 97.2922 69.1607 97.2922 68.7456C97.2922 68.3037 97.0047 68.0517 96.5009 68.0517H93.5374C92.2513 68.0517 91.457 67.2778 91.457 66.1688C91.457 65.0598 92.195 64.277 93.5552 64.277H98.2909V65.6825H93.5552C93.1581 65.6825 92.9151 65.9079 92.9151 66.3141C92.9151 66.7203 93.167 66.9457 93.5552 66.9457H96.5009C97.879 66.9457 98.6169 67.5595 98.6169 68.8642C98.6169 69.991 97.9234 70.8271 96.5009 70.8271H91.5578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.351 70.8271C102.487 70.8271 101.118 69.3861 101.118 67.4853C101.118 65.5846 102.487 64.277 104.351 64.277H105.972C107.899 64.277 109.232 65.5846 109.232 67.4853C109.232 69.3861 107.863 70.8271 105.972 70.8271H104.351ZM105.972 69.4216C107.063 69.4216 107.828 68.6388 107.828 67.5565C107.828 66.4742 107.063 65.6825 105.972 65.6825H104.351C103.299 65.6825 102.523 66.4653 102.523 67.5565C102.523 68.6477 103.287 69.4216 104.351 69.4216H105.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87 70.8271V64.277H113.274V69.4216H117.506V70.8271H111.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.754 64.277H127.123V67.9361C127.123 69.9643 126.107 70.9191 123.531 70.9191C120.956 70.9191 119.939 69.9643 119.939 67.9361V64.277H121.389V67.9361C121.389 69.0984 121.892 69.5402 123.576 69.5402C125.259 69.5402 125.754 69.0984 125.754 67.9361V64.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.911 70.8271C131.047 70.8271 129.677 69.3861 129.677 67.4853C129.677 65.5846 131.047 64.277 132.911 64.277H136.52V65.6825H132.911C131.859 65.6825 131.082 66.4653 131.082 67.5565C131.082 68.6477 131.847 69.4216 132.911 69.4216H136.52V70.8271H132.911ZM132.588 71.2512H133.957L133.272 72.6389L132.588 71.2512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.204 70.8271C140.34 70.8271 138.971 69.386 138.971 67.4853C138.971 65.5846 140.34 64.277 142.204 64.277H143.825C145.752 64.277 147.085 65.5846 147.085 67.4853C147.085 69.386 145.716 70.8271 143.825 70.8271H142.204ZM143.825 69.4216C144.916 69.4216 145.681 68.6388 145.681 67.5565C145.681 66.4742 144.916 65.6825 143.825 65.6825H142.204C141.152 65.6825 140.376 66.4653 140.376 67.5565C140.376 68.6477 141.14 69.4216 142.204 69.4216H143.825ZM144.187 63.4764C144.042 63.6484 143.825 63.7195 143.582 63.7195C143.185 63.7195 142.853 63.3963 142.439 63.3963C142.204 63.3963 141.961 63.5416 141.843 63.6839V63.0612C141.979 62.8982 142.196 62.8092 142.439 62.8092C142.853 62.8092 143.176 63.1413 143.582 63.1413C143.834 63.1413 144.068 62.996 144.187 62.8448V63.4764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.723 70.8271V64.277H155.665V65.6825H151.118V69.4216H155.673V70.8271H149.723ZM151.936 68.0517V66.9427H155.413V68.0517H151.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.364 70.8271V69.4216H163.308C163.811 69.4216 164.099 69.1607 164.099 68.7456C164.099 68.3037 163.811 68.0517 163.308 68.0517H160.344C159.058 68.0517 158.264 67.2778 158.264 66.1688C158.264 65.0598 159.002 64.277 160.362 64.277H165.098V65.6825H160.362C159.965 65.6825 159.722 65.9079 159.722 66.3141C159.722 66.7203 159.974 66.9457 160.362 66.9457H163.308C164.686 66.9457 165.424 67.5595 165.424 68.8642C165.424 69.991 164.73 70.8271 163.308 70.8271H158.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.672 70.8271V64.277H174.077V70.8271H172.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.291 66.4683V70.8301H176.958V65.0272C176.958 64.5142 177.227 64.1969 177.66 64.1969C177.867 64.1969 178.03 64.2681 178.226 64.4579L182.511 68.5765V64.2147H183.854V70.0799C183.854 70.6018 183.566 70.9191 183.151 70.9191C182.935 70.9191 182.763 70.839 182.576 70.6492L178.291 66.4683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.675 70.8271V64.277H190.527C192.409 64.277 193.769 65.5846 193.769 67.4853C193.769 69.3861 192.409 70.8271 190.527 70.8271H186.675ZM190.527 69.4216C191.591 69.4216 192.365 68.6388 192.365 67.5565C192.365 66.4742 191.591 65.6825 190.527 65.6825H188.071V69.4216H190.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.133 64.277H203.502V67.9361C203.502 69.9643 202.485 70.9191 199.91 70.9191C197.335 70.9191 196.318 69.9643 196.318 67.9361V64.277H197.767V67.9361C197.767 69.0984 198.271 69.5402 199.954 69.5402C201.638 69.5402 202.133 69.0984 202.133 67.9361V64.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.249 70.8271V69.4216H211.192C211.696 69.4216 211.983 69.1607 211.983 68.7456C211.983 68.3037 211.696 68.0517 211.192 68.0517H208.229C206.942 68.0517 206.148 67.2778 206.148 66.1688C206.148 65.0598 206.886 64.277 208.246 64.277H212.982V65.6825H208.246C207.849 65.6825 207.606 65.9079 207.606 66.3141C207.606 66.7203 207.858 66.9457 208.246 66.9457H211.192C212.57 66.9457 213.308 67.5595 213.308 68.8642C213.308 69.991 212.615 70.8271 211.192 70.8271H206.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.017 70.8271V65.6825H215.614V64.277H221.825V65.6825H219.422V70.8271H218.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.135 70.8271L228.54 69.0421H226.505V67.8441H229.044C229.729 67.8441 230.108 67.4379 230.108 66.744C230.108 66.0502 229.711 65.6795 229.044 65.6795H225.687V70.8242H224.291V64.274H229.044C230.573 64.274 231.483 65.2199 231.483 66.7055C231.483 67.7789 230.979 68.5261 230.159 68.8493L232.12 70.8212H230.132L230.135 70.8271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.494 70.8271V64.277H235.899V70.8271H234.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.468 70.8271L244.549 69.2763H241.784L242.425 68.1851H243.9L242.703 66.1658L239.956 70.8242H238.362L242.081 64.6358C242.244 64.3659 242.451 64.1851 242.756 64.1851C243.062 64.1851 243.269 64.3659 243.432 64.6358L247.151 70.8242H245.468V70.8271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.629 70.8271V64.277H251.034V70.8271H249.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.941 70.8271V69.4216H258.884C259.388 69.4216 259.675 69.1607 259.675 68.7456C259.675 68.3037 259.388 68.0517 258.884 68.0517H255.92C254.634 68.0517 253.84 67.2778 253.84 66.1688C253.84 65.0598 254.578 64.277 255.938 64.277H260.674V65.6825H255.938C255.541 65.6825 255.298 65.9079 255.298 66.3141C255.298 66.7203 255.55 66.9457 255.938 66.9457H258.884C260.262 66.9457 261 67.5595 261 68.8642C261 69.991 260.306 70.8271 258.884 70.8271H253.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3095 40.2143L78.4325 37.1749C78.4325 37.1393 78.4325 37.0978 78.4265 37.0652L77.7123 31.4402L77.7064 31.3927C77.7064 31.3927 77.7064 31.3779 77.6975 31.372L69.0203 30.2808C68.561 28.7389 67.9801 27.2444 67.2926 25.8063L72.9944 19.1672V19.1612L72.9351 19.0752L69.693 14.4406L69.6664 14.408C69.6664 14.408 69.6427 14.3843 69.6367 14.3694L61.573 17.5956C60.3343 16.3117 58.9859 15.1345 57.5367 14.0818L59.6052 5.63984C59.6052 5.63984 59.5934 5.63391 59.5845 5.62798L59.546 5.60426L54.3954 2.98301L48.6135 9.55689C47.0192 9.04687 45.3715 8.6614 43.6763 8.42418L41.5633 0.00593043C41.5456 0 41.5396 0 41.5248 0H41.4952L36.0127 0.0741304L35.8941 0.0800608C35.8349 0.0800608 35.7815 0.0859913 35.7282 0.0919217L33.6774 8.59913C32.0712 8.88675 30.5094 9.30188 28.9951 9.82969L23.0176 3.43372L17.8908 6.24771L20.2053 14.6215C18.8717 15.6623 17.6181 16.8068 16.4623 18.0433L8.33638 14.9921C8.31859 15.0159 8.28896 15.0514 8.27118 15.0781L8.24451 15.1107L5.12392 19.775L5.07651 19.8492V19.8551L10.9117 26.3786C10.239 27.8671 9.67589 29.4238 9.23729 31.0339L0.586777 32.3416C0.577886 32.3891 0.571959 32.4365 0.566032 32.4839L0.560105 32.5314L0.00592704 38.0289V38.0408C0 38.0793 0 38.1208 0 38.1683L8.19709 40.9941C8.29785 42.7643 8.54086 44.4901 8.93204 46.1654L1.84627 51.1618V51.1678C1.84627 51.1885 1.85516 51.2063 1.86702 51.23L1.87887 51.2686L3.97111 56.4518L4.00964 56.5378C4.01557 56.5556 4.02149 56.5763 4.03335 56.5971L12.7135 55.4406C13.5285 56.7631 14.4412 58.0293 15.431 59.2065L11.5666 67.0643C11.6051 67.1117 11.6466 67.1503 11.694 67.1918L11.7 67.1977L15.8104 70.7115L16.006 70.8775L23.0117 65.7418C24.4016 66.6017 25.8626 67.3489 27.3918 67.9805L27.3799 76.6627L27.4037 76.6716L32.978 77.9941H32.9958C33.0136 78 33.0432 78 33.0699 78.0059L37.1447 70.2489C37.8293 70.2964 38.5317 70.3231 39.234 70.3231C40.1764 70.3231 41.101 70.2845 42.0138 70.1955L46.2457 77.8606C46.2664 77.8606 46.2842 77.8606 46.299 77.8547L46.3613 77.8399L51.909 76.3899L51.7045 67.7048C53.2337 67.0376 54.6947 66.2488 56.0846 65.3504L63.2029 70.3142C63.2355 70.2934 63.2622 70.2667 63.2948 70.24L63.3126 70.2282L67.3697 66.5869L67.3815 66.575C67.4437 66.5187 67.5 66.4623 67.5534 66.403L63.5052 58.6282C64.495 57.3918 65.396 56.0752 66.1902 54.6934L74.9029 55.6126C74.9148 55.5978 74.9207 55.58 74.9266 55.5563L76.9389 50.1299L69.7168 45.3233C70.0516 43.6628 70.2532 41.9548 70.3035 40.2143H70.3095ZM39.237 63.6988C25.7411 63.6988 14.7613 52.7186 14.7613 39.209C14.7613 25.6995 25.7411 14.7164 39.237 14.7164C52.7328 14.7164 63.7156 25.7055 63.7156 39.209C63.7156 52.7126 52.7328 63.6988 39.237 63.6988Z",
    fill: "url(#paint8_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.237 64.6892C25.1929 64.6892 13.7686 53.2582 13.7686 39.2061C13.7686 25.1539 25.1929 13.7201 39.237 13.7201C53.2811 13.7201 64.7085 25.1539 64.7085 39.2061C64.7085 53.2582 53.2811 64.6892 39.237 64.6892ZM39.237 15.345C26.0879 15.345 15.3926 26.0494 15.3926 39.2061C15.3926 52.3627 26.0909 63.0642 39.237 63.0642C52.3832 63.0642 63.0845 52.3598 63.0845 39.2061C63.0845 26.0524 52.3862 15.345 39.237 15.345Z",
    fill: "url(#paint9_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.237 64.9264C25.0625 64.9264 13.5315 53.3887 13.5315 39.2061C13.5315 25.0235 25.0625 13.4828 39.237 13.4828C53.4116 13.4828 64.9456 25.0235 64.9456 39.2061C64.9456 53.3887 53.4116 64.9264 39.237 64.9264ZM39.237 13.9602C25.3263 13.9602 14.0086 25.2844 14.0086 39.2061C14.0086 53.1278 25.3263 64.449 39.237 64.449C53.1478 64.449 64.4684 53.1248 64.4684 39.2061C64.4684 25.2874 53.1508 13.9602 39.237 13.9602Z",
    fill: "url(#paint10_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M24.541 52.6207C24.0461 52.6207 23.7408 52.2649 23.4178 51.8883C20.8751 48.9231 19.34 45.4301 18.854 41.5101C18.3294 37.2757 19.0733 33.249 21.0707 29.5454C22.5347 26.8263 24.5469 24.5342 27.054 22.7373C30.5065 20.2613 34.3947 19.0041 38.6058 19.0041C38.9792 19.0041 39.3586 19.013 39.7349 19.0337C44.2958 19.268 48.3766 20.9344 51.8617 23.9856C53.3612 25.2992 54.674 26.8708 55.8743 28.7952C55.892 28.8219 55.9098 28.8486 55.9306 28.8753C56.0698 29.068 56.4433 29.584 56.1143 30.1681C55.9395 30.4795 55.6253 30.6574 55.249 30.6574C55.1334 30.6574 55.0326 30.6425 54.9526 30.6307C54.9259 30.6277 54.8993 30.6218 54.8726 30.6188C54.4607 30.6188 54.0398 30.6218 53.619 30.6218H52.2647C51.6483 30.6218 51.0319 30.6218 50.4125 30.6307H50.3829C49.7309 30.6307 49.2034 30.3964 48.7737 29.919C46.4058 27.2859 43.5193 25.827 39.9453 25.4593C39.5097 25.4149 39.0652 25.3911 38.6236 25.3911C33.6449 25.3911 28.9537 28.2259 26.6717 32.6174C24.9529 35.9266 24.6151 39.4048 25.6701 42.966C25.8716 42.7584 26.0761 42.5479 26.2806 42.3403C26.9118 41.6939 27.5638 41.0267 28.1802 40.3566C28.6929 39.7991 29.2885 39.5412 30.0531 39.5412C33.1115 39.5501 36.158 39.553 39.2045 39.553H46.9304C47.1141 39.553 47.3008 39.5441 47.4845 39.5382C47.6564 39.5323 47.8253 39.5293 47.9972 39.5263C48.018 39.5263 48.0417 39.5263 48.0654 39.5234C48.1187 39.5234 48.1691 39.5174 48.2225 39.5174C48.8655 39.5174 49.1174 39.9326 49.1945 40.1105C49.3249 40.407 49.3693 40.8547 48.83 41.3025C48.8152 41.3144 48.8033 41.3262 48.7914 41.3351C48.504 41.6287 48.2017 41.9193 47.9113 42.198C47.283 42.7999 46.6903 43.3722 46.1806 44.0068C45.4486 44.9201 44.5803 45.3263 43.3682 45.3263C43.2674 45.3263 43.1667 45.3263 43.063 45.3174C42.5088 45.2907 41.9102 45.2759 41.1782 45.2759C40.704 45.2759 40.2298 45.2818 39.7557 45.2848C39.2786 45.2907 38.8044 45.2966 38.3273 45.2966H35.2956C34.4154 45.2966 33.5353 45.2966 32.6551 45.2907C32.3943 45.2907 32.2491 45.353 32.0683 45.5339C30.4562 47.1618 28.8114 48.8075 27.22 50.3968L25.6642 51.9535C25.2907 52.3272 24.9974 52.6207 24.541 52.6207Z",
    fill: "url(#paint11_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.6561 58.9989C36.4068 58.9989 34.0952 58.5808 31.7867 57.7565C30.0797 57.1486 28.4201 56.2353 26.5649 54.8862C26.399 54.7646 26.0048 54.4799 25.9752 53.9907C25.9426 53.4955 26.3071 53.1545 26.4434 53.027C27.2377 52.2797 28.0763 51.4465 29.075 50.3998C29.3951 50.0647 29.7448 49.8957 30.1182 49.8957C30.4116 49.8957 30.6961 49.9965 30.9895 50.207C32.6994 51.4257 34.6435 52.1819 36.7683 52.4547C37.4499 52.5407 38.1256 52.5851 38.7746 52.5851C41.0091 52.5851 43.1014 52.0603 44.9921 51.0284C49.0966 48.7867 51.5178 45.2877 52.1845 40.6294C52.2972 39.8436 52.2646 39.0371 52.229 38.1801C52.2201 37.9637 52.2112 37.7502 52.2053 37.5337C52.2053 37.5337 52.2053 37.5278 52.2053 37.5248C52.1638 37.5218 52.1016 37.5159 52.0186 37.5159C48.8891 37.5218 45.7685 37.5248 42.6479 37.5248C39.5274 37.5248 36.4068 37.5248 33.2862 37.5189C33.2329 37.5189 33.1736 37.5278 33.1143 37.5337C33.0076 37.5456 32.8861 37.5604 32.7557 37.5604C32.0623 37.5604 31.8133 37.1186 31.7392 36.9288C31.4666 36.232 32.0682 35.7694 32.2964 35.5945C32.3438 35.5589 32.4149 35.5025 32.4357 35.4818C32.8446 35.0459 33.2595 34.6159 33.6744 34.186C34.2019 33.6404 34.7472 33.074 35.2688 32.5106C35.737 32.0036 36.3001 31.7693 37.0469 31.7693C38.6324 31.7782 40.2001 31.7782 41.7707 31.7782H46.545C47.3629 31.7782 50.6346 31.7782 51.4496 31.7782C53.284 31.7782 54.6946 31.7753 56.0193 31.7634C56.9528 31.7634 57.4981 32.1756 57.7619 33.0592C58.4257 35.2831 58.7221 37.2965 58.6658 39.2209C58.5028 44.8311 56.4224 49.6021 52.4868 53.3976C49.301 56.4725 45.404 58.308 40.9024 58.8566C40.1586 58.9485 39.4029 58.993 38.6531 58.993L38.6561 58.9989Z",
    fill: "url(#paint12_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3272 44.5761C36.4394 44.5761 34.5517 44.585 32.6639 44.5702C32.2135 44.5672 31.8786 44.7036 31.5585 45.0268C29.4337 47.1736 27.2911 49.3056 25.1573 51.4435C24.5498 52.0514 24.5172 52.0633 23.966 51.4198C21.4915 48.5347 20.0364 45.184 19.5711 41.4241C19.0673 37.3647 19.7608 33.501 21.7048 29.8894C23.1214 27.2592 25.0418 25.0709 27.4748 23.3244C31.1347 20.7002 35.2333 19.5259 39.6993 19.7543C44.1298 19.9826 48.0327 21.5897 51.3874 24.5283C52.9314 25.8804 54.185 27.449 55.2637 29.1777C55.3852 29.3705 55.6164 29.5869 55.486 29.8152C55.3674 30.0258 55.0829 29.8983 54.8755 29.8983C53.3848 29.9072 51.8942 29.8923 50.4035 29.9101C49.9531 29.9161 49.6123 29.7767 49.307 29.4357C46.8207 26.6662 43.7208 25.1213 40.0164 24.7418C34.3413 24.1606 28.681 27.1881 26.0316 32.2853C24.0964 36.0096 23.8326 39.8584 25.1899 43.8318C25.3411 44.2766 25.4804 44.1995 25.7352 43.9356C26.725 42.9037 27.7415 41.8955 28.7106 40.8429C29.0958 40.4248 29.4959 40.2587 30.062 40.2587C35.6867 40.2736 41.3085 40.2676 46.9333 40.2676C47.2918 40.2676 47.6475 40.2469 48.0061 40.2439C48.1987 40.2439 48.4447 40.1846 48.5395 40.3981C48.6254 40.5968 48.4032 40.7065 48.2846 40.8281C47.3926 41.7354 46.4146 42.5716 45.6234 43.559C44.9299 44.4219 44.1505 44.6532 43.1014 44.6028C41.516 44.5257 39.9216 44.582 38.3331 44.582L38.3272 44.5761Z",
    fill: "url(#paint13_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.545 32.5017C49.7041 32.5017 52.8662 32.5136 56.0253 32.4899C56.624 32.4869 56.8996 32.6856 57.0744 33.2697C57.6523 35.209 58.0079 37.1897 57.9486 39.2031C57.7916 44.5464 55.8653 49.1455 51.992 52.8817C48.8625 55.9002 45.1225 57.6201 40.8225 58.1449C37.8086 58.5126 34.8836 58.0945 32.0327 57.0774C30.2012 56.4251 28.5565 55.4406 26.9917 54.305C26.6332 54.044 26.5857 53.8839 26.9384 53.5518C27.8512 52.6949 28.7313 51.8023 29.5967 50.8979C29.9227 50.5569 30.2072 50.5302 30.5746 50.7941C32.4091 52.1018 34.4539 52.8846 36.6795 53.1693C39.7141 53.5548 42.6273 53.1426 45.3389 51.663C49.6834 49.2878 52.1965 45.6258 52.8988 40.7332C53.05 39.6716 52.9581 38.5893 52.9285 37.5159C52.9107 36.8991 52.5491 36.8013 52.0127 36.8013C45.7716 36.8161 39.5304 36.8102 33.2892 36.8043C32.984 36.8043 32.5246 36.9614 32.412 36.6708C32.3053 36.398 32.7558 36.2023 32.9632 35.9799C33.9027 34.9807 34.8717 34.011 35.8023 33.0058C36.1609 32.6203 36.555 32.4928 37.0677 32.4958C40.2268 32.5136 43.3889 32.5047 46.548 32.5047L46.545 32.5017Z",
    fill: "url(#paint14_linear_719_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.432 57.73L158.077 48.691H141.956L145.684 42.3329H154.296L147.311 30.5627L131.293 57.73H122L143.687 21.6275C144.632 20.0498 145.841 19 147.625 19C149.409 19 150.618 20.0498 151.563 21.6275L173.25 57.73H163.429H163.432Z",
    fill: "url(#paint15_linear_719_492)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_492",
    x1: 199.469,
    y1: 59.1353,
    x2: 199.469,
    y2: 17.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_492",
    x1: 147.817,
    y1: 59.1353,
    x2: 147.817,
    y2: 17.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_492",
    x1: 115.073,
    y1: 43.9504,
    x2: 115.073,
    y2: 34.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_492",
    x1: 109.401,
    y1: 59.1353,
    x2: 109.401,
    y2: 17.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_492",
    x1: 241.402,
    y1: 59.1353,
    x2: 241.402,
    y2: 17.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_492",
    x1: 109.401,
    y1: 57.6527,
    x2: 109.401,
    y2: 19.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B59547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#C7A447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D8B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D5B64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EBCF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EED563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E9D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3DF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F4E274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCEF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAEB85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1CC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E0BF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D1AE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B69540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AC8C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AA8B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9E813C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9B7E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#866D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#755E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6F5C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6D5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_719_492",
    x1: 199.469,
    y1: 57.6527,
    x2: 199.469,
    y2: 19.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B59547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#C7A447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D8B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D5B64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EBCF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EED563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E9D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3DF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F4E274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCEF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAEB85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1CC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E0BF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D1AE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B69540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AC8C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AA8B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9E813C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9B7E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#866D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#755E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6F5C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6D5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_719_492",
    x1: 241.405,
    y1: 57.6527,
    x2: 241.405,
    y2: 19.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B59547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#C7A447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D8B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D5B64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EBCF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EED563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E9D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3DF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F4E274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCEF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAEB85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1CC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E0BF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D1AE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B69540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AC8C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AA8B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9E813C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9B7E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#866D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#755E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6F5C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6D5D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_719_492",
    x1: 55.1926,
    y1: 5.89485,
    x2: 24.2987,
    y2: 70.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_719_492",
    x1: 22.5909,
    y1: 16.534,
    x2: 56.7501,
    y2: 63.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#50535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_719_492",
    x1: 24.0223,
    y1: 18.4822,
    x2: 54.4744,
    y2: 59.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_719_492",
    x1: 18.691,
    y1: 35.8109,
    x2: 56.2447,
    y2: 35.8109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#50535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_719_492",
    x1: 25.9752,
    y1: 45.3856,
    x2: 58.6747,
    y2: 45.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#50535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_719_492",
    x1: 19.4081,
    y1: 35.8109,
    x2: 55.5215,
    y2: 35.8109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_719_492",
    x1: 26.6924,
    y1: 45.3856,
    x2: 57.9546,
    y2: 45.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DBD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B4AEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#736E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBC9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#645D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_719_492",
    x1: 147.625,
    y1: 57.73,
    x2: 147.625,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E7438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#967B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#AF903E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#CFAC45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D5B64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#DCC258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#DFC75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E3CE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E8D76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EDE181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E9DB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1CC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2B34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CCA944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#BF9E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AA8C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9E813A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9A7E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#957A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#896F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#745E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#66522F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5E4E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#564930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8fc95aebb5240cceede7814dac606034.svg";
export { ForwardRef as ReactComponent };